import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { FormService } from '../../form.service';
import { Option } from '../../interfaces/option-interface';
import { BaseControlValueAccessorComponent } from '../base-control-value-accessor/base-control-value-accessor.component';

@Component({
  selector: 'app-radio-select',
  templateUrl: './radio-select.component.html',
  styleUrls: ['./radio-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioSelectComponent),
      multi: true,
    },
  ],
})
export class RadioSelectComponent extends BaseControlValueAccessorComponent implements OnInit {
  @Input() title = 'Egyéb';
  @Input() options: Option[] = [];
  @Input() required = false;
  @Input() formControl = new UntypedFormControl();
  selectedRadioButton: string;

  constructor(public formService: FormService) {
    super();
  }

  ngOnInit(): void {
    if (this.required) {
      this.title += ' *';
    }
    if (this.formControl.value) {
      this.selectedRadioButton = this.formControl.value;
    } else {
      this.formControl.setValue(null);
    }
  }

  selectRadioButton(event: Event, answerIndex: string): void {
    if (this.selectedRadioButton === answerIndex || this.formControl.disabled) {
      return;
    } else {
      this.selectedRadioButton = answerIndex;
    }
    this.formControl.setValue(this.selectedRadioButton);
    event.preventDefault();
  }
}
